import React from 'react'
import { ButtonWithModal } from 'newComponents'
import scrollIntoView from 'smooth-scroll-into-view-if-needed'

import './styles.scss'

const SeriesAgenda = ({ data }) => {
  const {
    primary: {
      agenda_title: agendaTitle,
      large_text: largeText,
      small_text: smallText,
      register_all_series_form_id: formId,
      register_all_series_form_flyout_text: flyoutText,
      register_all_series_button_text: buttonText
    },
    items: agendaItems
  } = data

  const largeTextHtml = largeText?.html
  const smallTextHtml = smallText?.html

  const onAgendaClick = (e) => {
    const num = e.currentTarget.dataset.scrollto
    const scrollToEl = document.querySelector(`div[data-scrollto="${num}"]`)

    let blockPosition = 'start'
    if (window.innerWidth > 768) {
      blockPosition = 'center'
    }

    scrollIntoView(scrollToEl, {
      block: blockPosition,
      scrollMode: 'if-needed'
    })
  }

  return (
    <section className="series-agenda">
      <div className="series-agenda-inner container">
        <div className="series-agenda-text-column">
          <div className="series-agenda-large-text" dangerouslySetInnerHTML={{ __html: largeTextHtml }} />
          <div className="series-agenda-small-text" dangerouslySetInnerHTML={{ __html: smallTextHtml }} />
          {buttonText.text && (
            <div className="series-agenda-register-all">
              <ButtonWithModal
                buttonText={buttonText.text}
                modalTitle={flyoutText.text}
                formId={formId}
                modalSubtitle="Sign up webinar by providing information"
                toggleCheckbox="all"
                addArrow
              />
            </div>
          )}
        </div>
        <div className="series-agenda-agenda-column">
          <h3 className="series-agenda-title">{agendaTitle}</h3>
          <div className="series-agenda-agenda-list">
            {agendaItems.map((agendaItem) => {
              const { agenda_number: agendaNumber, agenda_item: agendaItemText } = agendaItem
              const agendaNumberUpdated = parseInt(agendaNumber) < 10 ? `0${agendaNumber}` : agendaNumber
              return (
                <a
                  onClick={onAgendaClick}
                  key={agendaNumber}
                  data-scrollto={agendaNumberUpdated}
                  className="series-agenda-agenda-list-item"
                >
                  <div className="series-agenda-agenda-list-item-number">{agendaNumberUpdated}</div>
                  <div className="series-agenda-agenda-list-item-text">{agendaItemText}</div>
                </a>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

export default SeriesAgenda
